import { render, staticRenderFns } from "./PersonalCoaching.vue?vue&type=template&id=04364307&scoped=true"
import script from "./PersonalCoaching.vue?vue&type=script&lang=js"
export * from "./PersonalCoaching.vue?vue&type=script&lang=js"
import style0 from "./PersonalCoaching.vue?vue&type=style&index=0&id=04364307&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04364307",
  null
  
)

export default component.exports